/* eslint-env browser, es6 */
import m from "mithril";

export class HeaderView implements m.Component {
  view(): m.Children {
    // ATTENTION: Any changes to this header should also be made in webble/index.html
    return [
      m("nav.header", [
        m("h1", [
          "Webble",
          m("a", { class: "right", href: "/webble/rules" }, ["how to play"]),
        ]),
      ]),
    ];
  }
}

export class FooterView implements m.Component {
  view(): m.Children {
    // TODO: reinstate or remove this.
    return [
      // m("footer", ["created by ", m("a", { href: "/" }, ["ian fisher"])]),
    ];
  }
}
